import React from "react";

import "./src/styles/global.css";
import OldSiteHead from "./src/components/OldSiteHead";
import OldSiteNotice from "./src/components/OldSiteNotice";

export const wrapPageElement = ({ element, props }) => (
  <>
    {element}
    <OldSiteHead location={props.location} />
  </>
);

export const wrapRootElement = ({ element }) => (
  <>
    {element}
    <OldSiteNotice />
  </>
);
